import { getCurrentStep, showNextStep, unmarkFieldAsInvalid } from '../../../helpers';
import { isFormValid } from '../../../validators';

/**
 * Handles show/hide of the extra question block
 * @param {HTMLInputElement} $radio - The radio input element that was clicked
 */
export function initExtraQuestionBlock($radio) {
	const $activeStep = getCurrentStep(),
		oneWindowSelectedClass = 'step--one-window-selected';

	function checkExtraQuestionTrigger(radioButton, checkValue = false) {
		return window.modForm.opts.extraQuestionBlockTriggers.some(trigger => {
			if (checkValue) {
				return radioButton.name === trigger.name && radioButton.value === trigger.value;
			}
			return radioButton.name === trigger.name;
		});
	}

	if (!window.modForm.opts.formSwiperInstance.animating) {
		if (window.modForm.opts.extraQuestionBlock && checkExtraQuestionTrigger($radio)) {
			if (checkExtraQuestionTrigger($radio, true)) {
				window.modForm.opts.extraQuestionBlock.style.display = 'block';
				window.modForm.opts.extraQuestionInputs.forEach(($input) => {
					if ($input) {
						$input.setAttribute('data-required', 'nonempty');
					}
				});
				if ($radio.name === 'NumberOfWindows') {
					$activeStep.classList.add(oneWindowSelectedClass);
					window.Modalytics.heap('track', ['Open To Multiple Windows | Question Shown']);
				}
			} else {
				window.modForm.opts.extraQuestionBlock.style.display = 'none';
				window.modForm.opts.extraQuestionInputs.forEach(($input) => {
					if ($input) {
						$input.checked = false;
						$input.removeAttribute('data-required');
					}
				});
				unmarkFieldAsInvalid(window.modForm.opts.extraQuestionInputs[0]);
				if ($radio.name === 'NumberOfWindows') {
					$activeStep.classList.remove(oneWindowSelectedClass);
				}
				if (!isFormValid($activeStep)) {
					return;
				}
				showNextStep();
			}
		} else {
			if ($radio.name === 'MultipleWindows') {
				window.Modalytics.heap('track', [`Open To Multiple Windows | Clicked Option ${$radio.value}`]);
			}
			if (!isFormValid($activeStep)) {
				return;
			}
			showNextStep();
		}
	}
}
